export const customTooltipStylesAsClassName =
  'bg-white rounded-xl text-white min-w-[70px] max-w-sm z-[1005] shadow-[0px_4px_16px_rgba(0,0,0,0.1)] justify-center items-center space-x-2 p-2 border border-gray-light';

export const customTooltipContentStylesAsClassName =
  'p-2 flex text-sm font-normal text-center items-center';
